var map = {
	"./1.svg": 98754,
	"./2.svg": 53297,
	"./3.svg": 6848,
	"./atrakcja.svg": 10484,
	"./autobus.svg": 68066,
	"./bagaz.svg": 98884,
	"./basen.svg": 24368,
	"./bilet.svg": 39221,
	"./bilety.svg": 29142,
	"./check-in.svg": 44277,
	"./checklista.svg": 23792,
	"./click.svg": 35359,
	"./concierge.svg": 23086,
	"./covid.svg": 90804,
	"./czas-lotu.svg": 72229,
	"./data.svg": 71129,
	"./delfinarium.svg": 72373,
	"./depozyt.svg": 3200,
	"./dodatek.svg": 43105,
	"./dodatkowe-informacje.svg": 47276,
	"./e-sim.svg": 64636,
	"./formularz.svg": 70361,
	"./helikopter.svg": 17102,
	"./hotel.svg": 81937,
	"./informacje.svg": 55653,
	"./internet.svg": 55466,
	"./jacht.svg": 62777,
	"./jeep.svg": 39989,
	"./jet-ski.svg": 40258,
	"./karta-kredytowa.svg": 25657,
	"./klasa-lotu.svg": 91016,
	"./klub.svg": 82041,
	"./kod-qr.svg": 20915,
	"./lista.svg": 2474,
	"./lokalizacja.svg": 19232,
	"./lot-karta-pokladowa.svg": 21285,
	"./mail.svg": 14076,
	"./masaz.svg": 37719,
	"./maseczka.svg": 13292,
	"./miejsce-spotkania.svg": 15462,
	"./numer-lotu.svg": 29637,
	"./obraz.svg": 91481,
	"./parking.svg": 74931,
	"./paszport.svg": 8318,
	"./platnosc.svg": 64037,
	"./pobierz.svg": 26834,
	"./pociag.svg": 8906,
	"./pogoda.svg": 86229,
	"./posilek.svg": 29602,
	"./potwierdzenie.svg": 81354,
	"./potwierdzenie_2.svg": 44705,
	"./powiadomienie.svg": 79493,
	"./przesiadka.svg": 95439,
	"./przewodnik.svg": 69868,
	"./przylot.svg": 39733,
	"./rodzina.svg": 89504,
	"./room-service.svg": 28810,
	"./samochod.svg": 43645,
	"./silownia.svg": 608,
	"./sms.svg": 85548,
	"./speedboat.svg": 25868,
	"./stacja-benzynowa.svg": 30249,
	"./telefon-komorkowy.svg": 83167,
	"./telefon.svg": 76134,
	"./test.svg": 85685,
	"./transfer-lotnisko-hotel.svg": 60867,
	"./transfer.svg": 99896,
	"./ubezpieczenie.svg": 41825,
	"./upgrade.svg": 42819,
	"./uwaga.svg": 11214,
	"./wagon.svg": 29555,
	"./wifi.svg": 53202,
	"./wybrane-miejsce.svg": 89636,
	"./wycieczka-tropikalna.svg": 95549,
	"./wycieczka.svg": 24965,
	"./wycieczkowiec.svg": 68783,
	"./wylot.svg": 43326,
	"./wyspa.svg": 75493,
	"./zakaz.svg": 9648,
	"./zdjecie.svg": 78221,
	"./znak-zapytania.svg": 33775,
	"./znizka.svg": 14856,
	"./zwiedzanie.svg": 67307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87305;